import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import Typography from "components/Typography";
import { useMemo } from "react";
import { Line } from "react-chartjs-2";
import CollapsedChart from "./CollapsedChart";
import { LineChartProps } from "./type";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Title,
  Tooltip
);

const WeightLineChart = (props: LineChartProps) => {
  const { chartData, chartsToDisplay, handleToggleDisplayCharts } = props;
  const data = {
    labels: chartData.labels,
    datasets: [
      {
        label: "Weight",
        data: chartData.weight,
        borderColor: "#80ecff",
        backgroundColor: "#80ecff",
        fill: false,
        tension: 0.3,
        dates: chartData.date,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: function (tooltipItem: any) {
            const firstData = tooltipItem[0];
            const dataIndex = firstData.dataIndex;
            const dates = firstData.dataset.dates;
            return `${tooltipItem[0].label} @${dates[dataIndex - 1] || ""}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        position: "right",
      },
    },
  };

  const showChart = useMemo(
    () => chartsToDisplay.includes("weight"),
    [chartsToDisplay]
  );

  return (
    <>
      {showChart ? (
        <div className="h-[180px] flex ">
          <div className="w-full">
            <Line data={data} options={options as any} />
          </div>
          <div className="w-40 h-44 pl-6">
            <div className="flex items-center justify-between">
              <Typography htmlTag="p" type="pTinny" weight="bold">
                Weight (Lbs)
              </Typography>
              <button onClick={() => handleToggleDisplayCharts("weight")}>
                <img
                  src="/icons/chart-icon.svg"
                  alt="Show Encounter"
                  height={12}
                  width={12}
                  className=""
                />
              </button>
            </div>

            <div className="mt-6">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-[#80ecff]"></div>
                <Typography htmlTag="p" type="pTinny">
                  Lbs
                </Typography>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <CollapsedChart
          label="Weight (Lbs)"
          onButtonClick={() => handleToggleDisplayCharts("weight")}
        />
      )}
    </>
  );
};

export default WeightLineChart;
